import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Icon from 'ol/style/Icon';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';

export const DRAW = new Style({
  image: new Circle({
    fill: new Fill({ color: '#ffffff88' }),
    stroke: new Stroke({ color: '#0099ffff', width: 3 }),
    radius: 2
  }),
  fill: new Fill({ color: '#ffffff88' }),
  stroke: new Stroke({ color: '#0099ffff', width: 3 })
});

export const REDCIRCLE = new Style({
  image: new Circle({
    fill: new Fill({ color: '#ffffff88' }),
    stroke: new Stroke({ color: '#ff2200ff', width: 3 }),
    radius: 2
  }),
  fill: new Fill({ color: '#ffffff88' }),
  stroke: new Stroke({ color: '#ff2200ff', width: 3 })
});

export const WARNINGTEXT = new Style({
  stroke: new Stroke({ color: '#ff220000', width: 1 }),
  fill: new Fill({ color: '#ff2200ff' }),
  text: new Text({
    font: '18px Calibri,sans-serif',
    fill: new Fill({ color: '#ff2200ff' })
  })
});

export const BUFFER = new Style({
  stroke: new Stroke({ color: '#8a0ab5FF', width: 2 }),
  fill: new Fill({ color: '#8a0ab540' })
});

export const HIGHLIGHT = new Style({
  stroke: new Stroke({ color: '#00ffffff', width: 3 }),
  fill: new Fill({ color: '#00000000' }),
  image: new Circle({
    radius: 5,
    fill: new Fill({ color: '#00000000' }),
    stroke: new Stroke({ color: '#00ffffff', width: 3 })
  })
});

export const PARCEL = new Style({
  stroke: new Stroke({ color: '#ff0000ff', width: 3 }),
  fill: new Fill({ color: '#00000000' })
});

export const POINT = new Style({
  image: new Circle({
    radius: 5,
    fill: new Fill({ color: '#008080ff' }),
    stroke: new Stroke({ color: '#00ffffff', width: 3 })
  })
});

export const ROTATE = new Style({
  image: new Icon({
    src: './Content/eCounty/images/rotate.png',
    size: [24, 24]
  })
});

/**
 * Used to highlight points to end drawings
 * Radius needs to match ol/interaction/Draw snapTolerance
 */
export const STOP = new Style({
  fill: new Fill({ color: '#ff0000ff' }),
  stroke: new Stroke({ color: '#ffffffff' }),
  image: new Circle({
    radius: 8,
    fill: new Fill({ color: '#ff0000ff' }),
    stroke: new Stroke({ color: '#ffffffff' })
  })
});
